module.exports = __webpack_public_path__ + "static/img/hover11.903cc573.png";